/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/store'

Vue.use(Router)
const defaultPath = process.env.NODE_ENV === 'development' ? '' : ''

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: defaultPath + '/',
      name: 'Your Campaigns',
      meta: {
        requireAuth: true
      },
      redirect: '/venue/list'
    },
    /**
     * login section
     */
    {
      path: defaultPath + '/login',
      name: 'Login',
      meta: {
        noLogin: true,
        title: 'Mondo CheckIn | Log In'
      },
      component: () => import('../components/login/login.vue')
    },

    {
      path: defaultPath + '/forgot',
      name: 'Forgot Password',
      meta: {
        noLogin: true,
        title: 'Mondo CheckIn | Forgot Password'
      },
      component: () => import('../components/login/forgot.vue')
    },

    {
      path: defaultPath + '/resetPassword',
      name: 'Reset Password',
      meta: {
        noLogin: true,
        title: 'Mondo CheckIn | Reset Password'
      },
      component: () => import('../components/login/resetPassword.vue')
    },

    /**
     * end login sction
     */

    /**
     * venue section
     */
    {
      path: defaultPath + '/venue/list',
      name: 'Your Venues - List',
      meta: {
        requireAuth: true,
        title: 'Mondo CheckIn | Your Venues'
      },
      component: () => import('../components/venue/list.vue')
    },

    /**
     * end venue section
     */

    {
      path: defaultPath + '/venue/leads',
      name: 'Venue Leads',
      meta: {
        requireAuth: true,
        requireAdmin: true,
        module: 'referral',
        title: 'Mondo CheckIn | Your Venue CheckIn Details'
      },
      component: () => import('../components/leads/leads.vue')
    },

    {
      path: defaultPath + '/venue/marketing-list',
      name: 'Venue Marketing List',
      meta: {
        requireAuth: true,
        requireAdmin: true,
        module: 'referral',
        title: 'Mondo CheckIn | Your Venue CheckIn Marketing List'
      },
      component: () => import('../components/leads/marketingList.vue')
    },

    {
      path: defaultPath + '/invoices',
      name: 'Your Invoices',
      meta: {
        requireAuth: true,
        requireAdmin: true
      },
      component: () => import('../components/account/invoice.vue')
    },

    /**
     * start user section
     */
    {
      path: defaultPath + '/account/profile',
      name: 'Account Profile',
      meta: {
        requireAuth: true,
        title: 'Mondo CheckIn | Your Profile'
      },
      component: () => import('../components/account/profile.vue')
    },
    {
      path: defaultPath + '/profile',
      name: 'Account Profile',
      meta: {
        requireAuth: true,
        title: 'Mondo CheckIn | Your Profile'
      },
      component: () => import('../components/account/profile.vue')
    },
    /**
     * registration section
     */
    {
      path: defaultPath + '/registration',
      name: 'Registration',
      meta: {
        noLogin: true,
        title: 'Mondo CheckIn | Registration'
      },
      component: () => import('../components/account/reg.vue')
    },
    {
      path: defaultPath + '/test-registration',
      name: 'Registration',
      meta: {
        noLogin: true,
        title: 'Mondo CheckIn | Registration'
      },
      component: () => import('../components/account/test-reg.vue')
    },
    /**
     * page section
     */
    {
      path: defaultPath + '/checkin/privacy',
      name: 'Venue CheckIn - Privacy',
      meta: {
      },
      component: () => import('../components/page/element/checkin-privacyContent')
    },
    // {
    //   path: defaultPath + '/checkin/terms',
    //   name: 'Venue CheckIn - Privacy',
    //   meta: {
    //   },
    //   component: () => import('../components/page/element/checkin-tcContent')
    // },
    {
      path: defaultPath + '/venue/terms',
      name: 'Venue CheckIn - Terms',
      meta: {
      },
      component: () => import('../components/page/element/tcContent')
    },
    {
      path: defaultPath + '/checkin/:id',
      name: 'Venue CheckIn',
      meta: {
      },
      component: () => import('../components/checkIn.vue')
    }
    /**
     * end page section
     */
  ]
})

router.beforeEach((to, from, next) => {
  let defaultRoute = function () {
    if (store.state.common.accessToken) { // if log in but no access for current system, then redirect to campaign list page
      next({
        path: '/'
      })
    } else { // if not log in but no access for current system, then redirect to registration page
      next({
        path: '/registration'
      })
    }
  }

  // set page title
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    if (to.name) {
      document.title = to.name
    } else {
      document.title = 'Mondo CheckIn Portal'
    }
  }

  if (to.meta.requireAuth) { // need login or no
    if (store.state.common.accessToken) { // vuex state to check login status
      if (to.meta.requireAdmin) {
        // need admin to access
        if (store.state.common.admin) {
          next()
        } else {
          // if it is not admin, and not in the three layer account system
          next({
            path: '/'
          })
        }
      }
      next()
    } else {
      console.log(to)
      if (to.path === '/' || to.path === '/venue/list') {
        next({
          path: '/registration'
          // query: {redirect: to.fullPath} // put path as redirect after login
        })
      } else {
        next({
          path: '/login',
          query: {redirect: to.fullPath} // put path as redirect after login
        })
      }
    }
  } else if (to.meta.noLogin) {
    if (!store.state.common.accessToken) { // vuex state to check login status
      next()
    } else {
      next({
        path: '/',
        query: {redirect: to.fullPath} // put path as redirect after login
      })
    }
  } else {
    next()
  }
  // document.title = title
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js